import RenderData from "./render-data";

export default RenderData;
